import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column'
    },
    tableHeader: {
      background: colors.defaultGrey
    },
    tableHeaderFooter: {
      background: colors.defaultGrey
    },
    paperHeader: {
      justifyContent: 'space-between'
    },
    justifyRight: {
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    withMargin: {
      margin: theme.spacing(1)
    },
    withMarginLeft: {
      marginLeft: theme.spacing(1)
    },
    withMarginTopBottom: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    tableInfoChip: {
      marginLeft: theme.spacing(2),
      background: colors.defaultGrey
    },
    diseasesTable: {
      marginTop: theme.spacing(2)
    },
    tableRowArrowCell: {
      paddingBottom: 0,
      paddingTop: 0
    },
    greenChip: {
      color: colors.green,
      borderColor: colors.green
    },
    orangeChip: {
      color: colors.orange,
      borderColor: colors.orange
    },
    primaryAvatar: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.getContrastText(theme.palette.primary.main)
    },
    resultsTable: {
      marginTop: theme.spacing(2)
    },
    width100: {
      width: '100%'
    },
    pb12: {
      paddingBottom: 12
    }
  });
});
